export const ORDER_BASELINE = 1000000;
export const ORDER_STEP = 10000 * 2;
